import React, { useEffect, useState } from 'react';
import './FNFT.scss'; // Custom SCSS styles
import { client } from '../../../config/ipfsConfig';
import { ToastContainer, toast } from 'react-toastify';
import { addFractionalNFT, createFractionalNFT } from '../../../hooks/FNFThook';
import { useSelector } from 'react-redux';
import { ethers } from 'ethers';
import { contractAddress, fractional_nft_contract_address } from '../../../config/BackendUrl';
import { getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';
import { MdKeyboardArrowUp, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { FaCirclePlus } from 'react-icons/fa6';
import { etherToGwei } from '../../../hooks/Tokenhook';
import { collectionABI } from '../../../config/ABIs/CollectionABI';
import { AddActivityNFT, listNFTs, updateNFT } from '../../../hooks/NFTHook';
import { Box, Button, Paper, Step, StepLabel, Stepper } from '@mui/material';
import { Form } from 'react-bootstrap';

const CampaignCreationForm = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [errors, setErrors] = useState({});
  const [collection, setCollection] = useState([]);
  const [collectionshow, setCollectionshow] = useState(false);
  const [nfts, setNfts] = useState([]);
  const [selectCollection, setSelectCollection] = useState({ logo: "img/logos/dtoc.png", name: "Select Collection", symbol: "", contractAddress: contractAddress });
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    campaignName: "",
    campaignDescription: "",
    category: "",
    media: null,
    nftTokenId: "",
    fractionalTokenName: "",
    tokenSymbol: "",
    desire: "",
    tokens: "",
    campaignEndTime: "",
  });
  const walletAddress = localStorage.getItem("WalletAddress");
  const PROVIDER = useSelector((state) => state.valueFromHeader);

  useEffect(() => {
    const Params = {
      sortBy: 'createdAt', // Sort by creation date
      ownerAddress: walletAddress, // Filter by wallet address
    };
    getCollectionListbyWalletAddress(Params).then((data) => {
      console.log("walletAddress", walletAddress, data);

      if (data.success === true) {
        const Collect = data.data;
        const newArray = Collect.map((item) => ({ ...item, isActive: false }));
        setCollection(newArray);
      }
    });
  }, [walletAddress]);

  const addCollection = async (index, isActive, data) => {
    try {
      // Avoid unnecessary state updates for collection
      if (index !== null) {
        const updatedCollection = collection.map((item, i) =>
          i === index ? { ...item, isActive } : { ...item, isActive: false }
        );

        if (JSON.stringify(updatedCollection) !== JSON.stringify(collection)) {
          setCollection(updatedCollection);
        }
        setCollectionshow(false); // Close the dropdown
      }

      // Avoid redundant updates for selected collection
      if (selectCollection.contractAddress !== data.contractAddress) {
        setSelectCollection(data);

        // Update formData only if necessary
        if (formData.nftContract !== data.contractAddress) {
          setFormData((prev) => ({
            ...prev,
            nftContract: data.contractAddress,
          }));
        }

        // Load NFTs for the selected collection
        // const updatedNFTs = await loadNFTsForaCollection(data.contractAddress);
        const params = {
          listed: true,
          inAuction: false,
          inFractionNFt: false,
          draftStatus: false,
          contractAddress: data.contractAddress,
          currentOwner: walletAddress,
          sortBy: 'createdAt'
        };
        const allNFTs = await listNFTs(params); // Fetch all NFTs
        console.log("AllNFTs", allNFTs, allNFTs.data);
        if (allNFTs.success === true) {
          console.log("UpdatedData", allNFTs.success === true, allNFTs, allNFTs.data);

          // const UpdatedData = allNFTs.data.filter((data) => data.currentOwner.walletAddress === walletAddress)
          console.log("UpdatedData");

          setNfts(allNFTs.data)
        }

        // if (Array.isArray(updatedNFTs) && updatedNFTs.length > 0) {
        //   const FilterNFT = updatedNFTs.filter((data) => data.owner === walletAddress)
        //   console.log("FinterNFT", FilterNFT);
        //   setNfts(FilterNFT); // Set NFTs only if valid data is returned

        // } else {
        //   setNfts([]); // Ensure NFTs state is reset if no NFTs are found
        // }
      }
    } catch (error) {
      console.error("Error in addCollection:", error);
    }
  };

  const handlePrevious = (section) => {
    setActiveTab(section - 1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleNFT = (tokenId) => {
    setFormData({ ...formData, nftTokenId: tokenId })
  }
  console.log("Collection", collection, nfts, formData);

  const AddMedia = async (e) => {
    const file = e.target.files[0];
    // setType(file.type);
    try {
      const added = await client.add(file);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      setFormData({ ...formData, "media": url });
      console.log("url", url);

    } catch (error) {
      toast.error("Error uploading file: ", error);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) {
      const ethtoGwei = etherToGwei(formData.desire);
      const date = new Date(formData.campaignEndTime);
      const epoch = date.getTime() / 1000;
      const fund = ethers.parseEther(formData.desire); //'https://dtoc.infura-ipfs.io/ipfs/QmQ8dRMrrFuW9wdAdgmaa66QPzNKb8LXfMBvn5WhtiNVoK'

      console.log("ethtoGwei", fund, ethtoGwei);

      const body = {
        nftContract: formData.nftContract,
        nftTokenId: formData.nftTokenId,
        totalFundsDesired: fund.toString(),
        fractionalTokenSymbol: formData.tokenSymbol,
        fractionalTokenSupply: Number(formData.tokens),
        fractionalTokenName: formData.fractionalTokenName,
        campaignEndTime: epoch
      };


      console.log("formData", formData);
      createFractionalNFT(body).then(async (data) => {
        console.log("API Response:", data, data.data, data.data.data);

        const signer = await PROVIDER.getSigner(walletAddress);

        const sentTx = await signer.sendTransaction(data.data);

        const receipt = await sentTx.wait();
        if (receipt) {
          const body = {
            nftContract: formData.nftContract,
            nftTokenId: formData.nftTokenId,
            nftOwner: walletAddress,
            campaignName: formData.campaignName,
            campaignDescription: formData.campaignDescription,
            campaignMedia: [formData.media],
            category: formData.category,
            fractionalTokenName: formData.fractionalTokenName,
            fractionalTokenSymbol: formData.tokenSymbol,
            campaignEndTime: formData.campaignEndTime
          }
          addFractionalNFT(body).then((data) => {
            console.log("data", data);

          })
          const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
          // Filter logs for Transfer events
          const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
          console.log("Step 5 => logs", logs);

          let tokenId, from, to, transactionHash;
          if (logs.length > 0) {
            logs.forEach(async (log) => {
              // Extract tokenId directly from topics[3]
              const rawFrom = log.topics[1];
              const rawTo = log.topics[2];
              // Decode the 'from' and 'to' addresses, handling zero address scenarios
              from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
              to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

              transactionHash = log.transactionHash;
              // tokenId = getBigInt(log.topics[3]).toString();
              console.log("Step 6 => Minted Token ID:", tokenId, from, to, transactionHash);

              const NFTbody = {
                inFractionNFt: true,
              }

              console.log("Step 7 => NFTbody", NFTbody);
              const NFTId = nfts.filter((data) => data.tokenId === formData.nftTokenId);
              console.log("Step 8 => NFTbody", NFTId, NFTId._id, NFTbody);
              await updateNFT(NFTId[0]._id, NFTbody)
              const activityBody = {
                event: "Fractionalized",
                price: 0,
                from: from,
                to: to
              }
              await AddActivityNFT(NFTId[0]._id, activityBody).then((data) => {
                toast.success("Campaign created successfully!");
                setTimeout(() => navigate("/launchpad"), 2000);
              })
            });
          } else {
            console.error("Unable to find Transfer event in raw logs.");
          }
        }
      })
    }
  };

  const checksetApproved = async (e) => {
    e.preventDefault();
    try {
      // const Provider = new BrowserProvider(window.ethereum);
      const wallet = await PROVIDER.getSigner();

      const contracts = new ethers.Contract(
        formData.nftContract,
        collectionABI,
        wallet
      );

      const test = await contracts.setApprovalForAll(
        fractional_nft_contract_address,
        true
      );
      const receipt = await test.wait();
      if (receipt) {
        console.log("res", receipt);
        handleSubmit(e)
      }
    } catch (error) {
      toast.error("Error calling function:", error);
    }
  };

  const steps = [
    'Basic Details',
    'Select NFT',
    'Tokenization',
    'Preview',
  ];

  const validateFields = () => {
    let newErrors = {};

    if (!formData.campaignName.trim()) newErrors.campaignName = "Campaign Name is required";
    if (!formData.campaignDescription.trim()) newErrors.campaignDescription = "Campaign Description is required";
    if (!formData.category) newErrors.category = "Category is required";
    if (activeStep === 0 && !formData.media) newErrors.media = "Campaign Media is required";
    if (activeStep === 2 && !formData.fractionalTokenName) newErrors.fractionalTokenName = "Token Name is required";
    if (activeStep === 2 && !formData.desire) newErrors.desire = "Fund Desired is required";
    if (activeStep === 2 && !formData.campaignEndTime) newErrors.campaignEndTime = "Campaign End Date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleNext = (e) => {
    e.preventDefault();
    if (validateFields()) {
      if(activeStep === steps.length - 1 ){
        checksetApproved(e)
      }
      else{
        setActiveStep(activeStep + 1);
      }
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const renderStepContent = (activeStep, formData, handleChange, AddMedia, errors) => {
    switch (activeStep) {
      case 0:
        return (
          <div className="container">
            <Form className="space-y-4">
              <div className="d-flex gap-4">
                <Form.Group className="flex-grow-1">
                  <p>Campaign Name</p>
                  <Form.Control
                    type="text"
                    className="form-control"
                    placeholder="Campaign Name"
                    name="campaignName"
                    isInvalid={!!errors.campaignName}
                    defaultValue={formData.campaignName}
                    onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.campaignName && <p className="error" style={{color:"red"}}>{errors.campaignName}</p>}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              <Form.Group>
                <p>Campaign Description</p>
                <Form.Control
                  onChange={(e) => handleChange(e)}
                  as="textarea"
                  name="campaignDescription"
                  rows={4}
                  //   {...register('bio')}
                  defaultValue={formData.campaignDescription || ''}
                  isInvalid={!!errors.campaignDescription}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.campaignDescription && <p className="error" style={{color:"red"}}>{errors.campaignDescription}</p>}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="documentType">
                <p>Category</p>
                <Form.Control
                  as="select"
                  // {...register('documentType')}
                  onChange={handleChange}
                  name='category'
                  isInvalid={!!errors.category}
                >
                  <option value="">Select Category</option>
                  <option value="Art">Art</option>
                  <option value="Collectibles">Collectibles</option>
                  <option value="Gaming">Gaming</option>
                  <option value="Real Estate">Real Estate</option>
                  <option value="Music">Music</option>
                  <option value="Charity">Charity</option>
                  <option value="Other">Other</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.category && <p className="error" style={{color:"red"}}>{errors.category}</p>}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="frontImage">
                <p>Campaign Media</p>
                <Form.Control
                  type="file"
                  // accept="image/*"
                  onChange={AddMedia}
                  isInvalid={!!errors.media}
                  name="media"
                />
                <Form.Control.Feedback type="invalid">
                {errors.media && <p className="error" style={{color:"red"}}>{errors.media}</p>}
                </Form.Control.Feedback>
              </Form.Group>

            </Form>
          </div>
        );
      case 1:
        return (
          <>
            <div className="container">
              <div className="mt-40 mb-120">
                <div className="row">
                  <div className="col-lg-2"></div>
                  <div className="col-lg-8">
                    <div className="space-y-10 colletion_ui">
                      <span className="variationInput">Choose Collection</span>
                      <div className="d-flex flex-column flex-md-row p-2">
                        <div
                          className="isSelected_collection d-flex justify-content-between"
                          onClick={() => setCollectionshow(!collectionshow)}
                        >
                          <div className="d-flex justify-content-start">
                            <img src={selectCollection.logo} alt="Collection Icon" />
                            <div>
                              <span className="ml-10">{selectCollection.name}</span>
                              <p className="ml-10">{selectCollection.symbol}</p>
                            </div>
                          </div>
                          <div>
                            {collectionshow ? (
                              <MdKeyboardArrowUp size={32} />
                            ) : (
                              <MdOutlineKeyboardArrowDown size={32} />
                            )}
                          </div>
                        </div>
                      </div>

                      {collectionshow && (
                        <div className="colletion_ui_data">
                          {collection.map((data, i) => (
                            <div
                              key={i}
                              className={`${data.isActive
                                ? "isSelected_collection"
                                : "choose_collection"
                                } d-flex justify-content-start m-2`}
                              onClick={() => addCollection(i, true, data)}
                            >
                              <img
                                src={data.logo || `img/logos/dtoc.png`}
                                alt="Collection Logo"
                              />
                              <div>
                                <span className="ml-10">{data.name}</span>
                                <p className="ml-10">{data.symbol}</p>
                              </div>
                            </div>
                          ))}
                          <div className="d-flex flex-column flex-md-row p-2">
                            <Link
                              to="/collectionAdd"
                              className="choose_collection d-flex justify-content-start"
                            >
                              <FaCirclePlus color="black" size="50" />
                              <div>
                                <span className="ml-10">Create</span>
                                <p className="ml-10">ERC-721</p>
                              </div>
                            </Link>
                          </div>
                        </div>
                      )}
                      {nfts.length !== 0 ? (
                        <div className="nft-cards row" style={{ minHeight: "50vh" }}>
                          {nfts.map((nft) => (
                            <div
                              key={nft.tokenId}
                              className={`col-lg-3 col-md-6 col-sm-12 ${formData.nftTokenId === nft.tokenId ? "selected-nft" : ""
                                }`} // Add conditional class
                              onClick={() => handleNFT(nft.tokenId)} // Handle click
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  formData.nftTokenId === nft.tokenId ? "#f0f8ff" : "transparent", // Inline style fallback
                                borderRadius: "10px",
                                padding: "10px",
                              }}
                            >
                              <div className="card__item four">
                                <div className="card_body space-y-10">
                                  <div className="card_head">
                                    {nft.assetType?.split("/")[0] !== "image" ? (
                                      <div className="video-wrapper">
                                        <video
                                          style={{ borderRadius: "18px" }}
                                          muted
                                          loop
                                          playsInline
                                        >
                                          <source src={nft.imageUri} type={nft.assetType} />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    ) : (
                                      <img
                                        src={nft.imageUri}
                                        alt={`Preview ${nft.assetType}`}
                                        style={{ borderRadius: "18px" }}
                                      />
                                    )}
                                  </div>
                                  <div className="card_footer d-block space-y-10">
                                    <div className="d-flex align-items-center space-x-10 justify-content-between">
                                      <h6 className="card_title">
                                        <div className="color_black">
                                          {nft.title?.slice(0, 15) +
                                            (nft.title?.length > 15 ? "..." : "")}
                                        </div>
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div
                          style={{ minHeight: "50vh" }}
                          className="d-flex align-items-center justify-content-center"
                        >
                          {selectCollection.symbol !== "" ? (
                            <div>
                              <h2>No NFTs</h2>
                              <Link to="/mint" className="btn btn-grad btn-lg">
                                Add NFT
                              </Link>
                            </div>
                          ) : (
                            <div>
                              <h2 style={{ marginTop: "-5vh" }}>Select A Collection</h2>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>

        )
      case 2:
        return (
          <div className="container">
            <div className=" mt-40 mb-120">
              <div className="row">
                <div className="form-group space-y-10">
                  <div className="space-y-20">
                    <div className="space-y-10">
                      <span className="nameInput">Token Name</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Token Name"
                        name="fractionalTokenName"
                        value={formData.fractionalTokenName}
                        onChange={handleChange}
                      />
                      {errors.fractionalTokenName && <p className="error" style={{color:"red"}}>{errors.fractionalTokenName}</p>}
                    </div>

                    <div className="space-y-10">
                      <span className="nameInput">Token Symbol</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Token Symbol"
                        name="tokenSymbol"
                        value={formData.tokenSymbol}
                        onChange={handleChange}
                      />
                      {errors.tokenSymbol && <p className="error" style={{color:"red"}}>{errors.tokenSymbol}</p>}
                    </div>
                    <div className="space-y-10">
                      <span className="nameInput">Fund Desired (ETH)</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Fund Desire"
                        name="desire"
                        value={formData.desire}
                        onChange={handleChange}
                      />
                      {errors.desire && <p className="error" style={{color:"red"}}>{errors.desire}</p>}
                    </div>
                    <div className="space-y-10">
                      <span className="nameInput"> Total Tokens Supply</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Total Tokens"
                        name="tokens"
                        value={formData.tokens}
                        onChange={handleChange}
                      />
                      {errors.tokens && <p className="error" style={{color:"red"}}>{errors.tokens}</p>}
                    </div>

                    <div className="space-y-10">
                      <span className="nameInput">Campaign End Date</span>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="campaignEndTime"
                        value={formData.campaignEndTime}
                        onChange={handleChange}
                      />
                      {errors.campaignEndTime && <p className="error" style={{color:"red"}}>{errors.campaignEndTime}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="container">
            <div className="b mt-40 mb-120">
              <div className="row">
                {/* <div className="col-lg-2"></div>
                <div className="col-lg-8"> */}
                <form className="form-group space-y-10">
                  <div className="space-y-20">

                    {/* Campaign Name */}
                    <div className="space-y-10">
                      <span className="nameInput">Campaign Name</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Campaign Name"
                        name="campaignName"
                        value={formData.campaignName}
                        onChange={handleChange}
                      />
                      {errors.campaignName && <p className="error">{errors.campaignName}</p>}
                    </div>

                    {/* Campaign Description */}
                    <div className="space-y-10">
                      <span className="nameInput">Campaign Description</span>
                      <textarea
                        className="form-control"
                        placeholder="Campaign Description"
                        name="campaignDescription"
                        value={formData.campaignDescription}
                        onChange={handleChange}
                      />
                      {errors.campaignDescription && <p className="error">{errors.campaignDescription}</p>}
                    </div>

                    {/* Category */}
                    <div className="space-y-10">
                      <span className="nameInput">Category</span>
                      <select
                        className="form-control"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                      >
                        <option value="">Select Category</option>
                        <option value="Art">Art</option>
                        <option value="Collectibles">Collectibles</option>
                        <option value="Gaming">Gaming</option>
                        <option value="Real Estate">Real Estate</option>
                        <option value="Music">Music</option>
                        <option value="Charity">Charity</option>
                        <option value="Other">Other</option>
                      </select>
                      {errors.category && <p className="error">{errors.category}</p>}
                    </div>

                    {/* Campaign Media */}
                    <div className="space-y-10">
                      <span className="nameInput">Campaign Media</span>
                      <input
                        type="file"
                        className="form-control"
                        name="media"
                        onChange={AddMedia}
                      />
                      {formData.media && (
                        <div className="media-preview mt-10">
                          <p><strong>Current Media:</strong></p>
                          <img
                            src={formData.media}
                            alt="Campaign Media"
                            style={{ width: "100%", borderRadius: "10px" }}
                          />
                        </div>
                      )}
                      {errors.media && <p className="error">{errors.media}</p>}
                    </div>

                    {/* Selected Collection */}
                    <div className="space-y-10">
                      <span className="nameInput">Selected Collection</span>
                      <div className="selected-collection">
                        {selectCollection.name ? (
                          <div className="d-flex align-items-center">
                            <img src={selectCollection.logo} alt="Collection Logo" style={{ width: "50px" }} />
                            <div className="ml-10">
                              <p><strong>Name:</strong> {selectCollection.name}</p>
                              <p><strong>Symbol:</strong> {selectCollection.symbol}</p>
                            </div>
                          </div>
                        ) : (
                          <p>No collection selected</p>
                        )}
                      </div>
                    </div>

                    {/* Selected NFT */}
                    <div className="space-y-10">
                      <span className="nameInput">Selected NFT</span>
                      {formData.nftTokenId ? (
                        <div className="nft-preview">
                          <p><strong>NFT Title:</strong> {nfts.find(nft => nft.tokenId === formData.nftTokenId)?.title || "N/A"}</p>
                          {nfts.find(nft => nft.tokenId === formData.nftTokenId)?.type?.split("/")[0] === "image" ? (
                            <img
                              src={nfts.find(nft => nft.tokenId === formData.nftTokenId)?.image}
                              alt="Selected NFT"
                              style={{ width: "100%", borderRadius: "10px" }}
                            />
                          ) : (
                            <video
                              style={{ width: "100%", borderRadius: "10px" }}
                              muted
                              loop
                              playsInline
                            >
                              <source
                                src={nfts.find(nft => nft.tokenId === formData.nftTokenId)?.image}
                                type={nfts.find(nft => nft.tokenId === formData.nftTokenId)?.type}
                              />
                            </video>
                          )}
                        </div>
                      ) : (
                        <p>No NFT Selected</p>
                      )}
                    </div>

                    {/* Token Name */}
                    <div className="space-y-10">
                      <span className="nameInput">Token Name</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Token Name"
                        name="fractionalTokenName"
                        value={formData.fractionalTokenName}
                        onChange={handleChange}
                      />
                      {errors.fractionalTokenName && <p className="error">{errors.fractionalTokenName}</p>}
                    </div>

                    {/* Token Symbol */}
                    <div className="space-y-10">
                      <span className="nameInput">Token Symbol</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Token Symbol"
                        name="tokenSymbol"
                        value={formData.tokenSymbol}
                        onChange={handleChange}
                      />
                      {errors.tokenSymbol && <p className="error">{errors.tokenSymbol}</p>}
                    </div>

                    {/* Fund Desired */}
                    <div className="space-y-10">
                      <span className="nameInput">Fund Desired (ETH)</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Fund Desired"
                        name="desire"
                        value={formData.desire}
                        onChange={handleChange}
                      />
                      {errors.desire && <p className="error">{errors.desire}</p>}
                    </div>

                    {/* Total Tokens Supply */}
                    <div className="space-y-10">
                      <span className="nameInput">Total Tokens Supply</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Total Tokens"
                        name="tokens"
                        value={formData.tokens}
                        onChange={handleChange}
                      />
                      {errors.tokens && <p className="error">{errors.tokens}</p>}
                    </div>

                    {/* Campaign End Date */}
                    <div className="space-y-10">
                      <span className="nameInput">Campaign End Date</span>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="campaignEndTime"
                        value={formData.campaignEndTime}
                        onChange={handleChange}
                      />
                      {errors.campaignEndTime && <p className="error">{errors.campaignEndTime}</p>}
                    </div>
                  </div>
                  <div style={{ float: "right" }}>
                    <button
                      className="btn btn-prev"
                      onClick={() => handlePrevious(4)}
                      disabled={activeTab === 1 || activeTab === 2 || activeTab === 3}
                    >
                      Previous
                    </button>
                    <button
                      className="btn btn-next"
                      onClick={(e) => checksetApproved(e)}
                    >
                      Submit
                    </button>  </div>
                </form>
                {/* </div>
                <div className="col-lg-2"></div> */}
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container">
      <Link to="/launchpad" className="btn btn-white btn-sm my-40">
        back to LaunchPad
      </Link>
      <Paper sx={{ p: 3 }}>
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <form >
          {renderStepContent(activeStep, formData, handleChange, AddMedia, errors)}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
              variant='outlined'
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              Back
            </Button>
           
              <Button type="button" variant="contained"  onClick={(e) => handleNext(e)}>
               {activeStep !== steps.length - 1 ? "Next" : "Submit"} 
              </Button>
            
          </Box>
        </form>
      </Paper>
    </div>
  );
};

export default CampaignCreationForm;

// import React, { useEffect, useState } from "react";
// import "./FNFT.scss"; // Custom SCSS styles
// import { client } from "../../../config/ipfsConfig";
// import { ToastContainer, toast } from "react-toastify";
// import { addFractionalNFT, createFractionalNFT } from "../../../hooks/FNFThook";
// import { useSelector } from "react-redux";
// import { ethers } from "ethers";
// import {
//   contractAddress,
//   fractional_nft_contract_address,
// } from "../../../config/BackendUrl";
// import { getCollectionListbyWalletAddress } from "../../../hooks/Collectionhook";
// import { MdKeyboardArrowUp, MdOutlineKeyboardArrowDown } from "react-icons/md";
// import { Link } from "react-router-dom";
// import { FaCirclePlus } from "react-icons/fa6";
// import { etherToGwei } from "../../../hooks/Tokenhook";
// import { collectionABI } from "../../../config/ABIs/CollectionABI";
// import { AddActivityNFT, listNFTs, updateNFT } from "../../../hooks/NFTHook";
// import { Box, Button, Paper, Step, StepLabel, Stepper } from "@mui/material";
// import { Form } from "react-bootstrap";

// const CampaignCreationForm = () => {
//   // const steps = ['Basic Details', 'Select NFT', 'Tokenization', 'Preview'];
//   const [activeTab, setActiveTab] = useState(1);
//   const [errors, setErrors] = useState({});
//   const [collection, setCollection] = useState([]);
//   const [collectionshow, setCollectionshow] = useState(false);
//   const [nfts, setNfts] = useState([]);
//   const [selectCollection, setSelectCollection] = useState({
//     logo: "img/logos/dtoc.png",
//     name: "Select Collection",
//     symbol: "",
//     contractAddress: contractAddress,
//   });
//   const [formData, setFormData] = useState({
//     campaignName: "",
//     campaignDescription: "",
//     category: "",
//     media: null,
//     nftTokenId: "",
//     fractionalTokenName: "",
//     tokenSymbol: "",
//     desire: "",
//     tokens: "",
//     campaignEndTime: "",
//   });
//   const walletAddress = localStorage.getItem("WalletAddress");
//   const PROVIDER = useSelector((state) => state.valueFromHeader);

//   useEffect(() => {
//     const Params = {
//       sortBy: "createdAt", // Sort by creation date
//       ownerAddress: walletAddress, // Filter by wallet address
//     };
//     getCollectionListbyWalletAddress(Params).then((data) => {
//       console.log("walletAddress", walletAddress, data);

//       if (data.success === true) {
//         const Collect = data.data;
//         const newArray = Collect.map((item) => ({ ...item, isActive: false }));
//         setCollection(newArray);
//       }
//     });
//   }, [walletAddress]);

//   const addCollection = async (index, isActive, data) => {
//     try {
//       // Avoid unnecessary state updates for collection
//       if (index !== null) {
//         const updatedCollection = collection.map((item, i) =>
//           i === index ? { ...item, isActive } : { ...item, isActive: false }
//         );

//         if (JSON.stringify(updatedCollection) !== JSON.stringify(collection)) {
//           setCollection(updatedCollection);
//         }
//         setCollectionshow(false); // Close the dropdown
//       }

//       // Avoid redundant updates for selected collection
//       if (selectCollection.contractAddress !== data.contractAddress) {
//         setSelectCollection(data);

//         // Update formData only if necessary
//         if (formData.nftContract !== data.contractAddress) {
//           setFormData((prev) => ({
//             ...prev,
//             nftContract: data.contractAddress,
//           }));
//         }

//         // Load NFTs for the selected collection
//         // const updatedNFTs = await loadNFTsForaCollection(data.contractAddress);
//         const params = {
//           listed: true,
//           inAuction: false,
//           inFractionNFt: false,
//           draftStatus: false,
//           contractAddress: data.contractAddress,
//           currentOwner: walletAddress,
//           sortBy: "createdAt",
//         };
//         const allNFTs = await listNFTs(params); // Fetch all NFTs
//         console.log("AllNFTs", allNFTs, allNFTs.data);
//         if (allNFTs.success === true) {
//           console.log(
//             "UpdatedData",
//             allNFTs.success === true,
//             allNFTs,
//             allNFTs.data
//           );

//           // const UpdatedData = allNFTs.data.filter((data) => data.currentOwner.walletAddress === walletAddress)
//           console.log("UpdatedData");

//           setNfts(allNFTs.data);
//         }

//         // if (Array.isArray(updatedNFTs) && updatedNFTs.length > 0) {
//         //   const FilterNFT = updatedNFTs.filter((data) => data.owner === walletAddress)
//         //   console.log("FinterNFT", FilterNFT);
//         //   setNfts(FilterNFT); // Set NFTs only if valid data is returned

//         // } else {
//         //   setNfts([]); // Ensure NFTs state is reset if no NFTs are found
//         // }
//       }
//     } catch (error) {
//       console.error("Error in addCollection:", error);
//     }
//   };

//   const handlePrevious = (section) => {
//     setActiveTab(section - 1);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleNFT = (tokenId) => {
//     setFormData({ ...formData, nftTokenId: tokenId });
//   };
//   console.log("Collection", collection, nfts, formData);

//   const AddMedia = async (e) => {
//     const file = e.target.files[0];
//     // setType(file.type);
//     try {
//       const added = await client.add(file);
//       const url = `https://ipfs.infura.io/ipfs/${added.path}`;
//       setFormData({ ...formData, media: url });
//       console.log("url", url);
//     } catch (error) {
//       toast.error("Error uploading file: ", error);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateFields()) {
//       const ethtoGwei = etherToGwei(formData.desire);
//       const date = new Date(formData.campaignEndTime);
//       const epoch = date.getTime() / 1000;
//       const fund = ethers.parseEther(formData.desire);

//       const actionButtons = document.querySelector(".action-buttons");
//       if (actionButtons) {
//         actionButtons.style.display = "flex";
//         actionButtons.style.justifyContent = "space-between";
//       } //'https://dtoc.infura-ipfs.io/ipfs/QmQ8dRMrrFuW9wdAdgmaa66QPzNKb8LXfMBvn5WhtiNVoK'

//       console.log("ethtoGwei", fund, ethtoGwei);

//       const body = {
//         nftContract: formData.nftContract,
//         nftTokenId: formData.nftTokenId,
//         totalFundsDesired: fund.toString(),
//         fractionalTokenSymbol: formData.tokenSymbol,
//         fractionalTokenSupply: Number(formData.tokens),
//         fractionalTokenName: formData.fractionalTokenName,
//         campaignEndTime: epoch,
//       };

//       console.log("formData", formData, body);
//       createFractionalNFT(body).then(async (data) => {
//         console.log("API Response:", data, data.data, data.data.data);

//         const signer = await PROVIDER.getSigner(walletAddress);

//         const sentTx = await signer.sendTransaction(data.data);

//         const receipt = await sentTx.wait();
//         if (receipt) {
//           const body = {
//             nftContract: formData.nftContract,
//             nftTokenId: formData.nftTokenId,
//             nftOwner: walletAddress,
//             campaignName: formData.campaignName,
//             campaignDescription: formData.campaignDescription,
//             campaignMedia: [formData.media],
//             category: formData.category,
//             fractionalTokenName: formData.fractionalTokenName,
//             fractionalTokenSymbol: formData.tokenSymbol,
//             campaignEndTime: formData.campaignEndTime,
//           };
//           addFractionalNFT(body).then((data) => {
//             console.log("data", data);
//           });
//           const transferEventSignatures = ethers.keccak256(
//             ethers.toUtf8Bytes("Transfer(address,address,uint256)")
//           );
//           // Filter logs for Transfer events
//           const logs = receipt.logs.filter(
//             (log) => log.topics[0] === transferEventSignatures
//           );
//           console.log("Step 5 => logs", logs);

//           let tokenId, from, to, transactionHash;
//           if (logs.length > 0) {
//             logs.forEach(async (log) => {
//               // Extract tokenId directly from topics[3]
//               const rawFrom = log.topics[1];
//               const rawTo = log.topics[2];
//               // Decode the 'from' and 'to' addresses, handling zero address scenarios
//               from =
//                 rawFrom !== `0x${"0".repeat(64)}`
//                   ? ethers.getAddress(rawFrom.slice(-40))
//                   : "Minting (no from)";
//               to =
//                 rawTo !== `0x${"0".repeat(64)}`
//                   ? ethers.getAddress(rawTo.slice(-40))
//                   : "Burning (no to)";

//               transactionHash = log.transactionHash;
//               // tokenId = getBigInt(log.topics[3]).toString();
//               console.log(
//                 "Step 6 => Minted Token ID:",
//                 tokenId,
//                 from,
//                 to,
//                 transactionHash
//               );

//               const NFTbody = {
//                 inFractionNFt: true,
//               };

//               console.log("Step 7 => NFTbody", NFTbody);
//               const NFTId = nfts.filter(
//                 (data) => data.tokenId === formData.nftTokenId
//               );
//               console.log("Step 8 => NFTbody", NFTId, NFTId._id, NFTbody);
//               await updateNFT(NFTId[0]._id, NFTbody);
//               const activityBody = {
//                 event: "Fractionalized",
//                 price: 0,
//                 from: from,
//                 to: to,
//               };
//               await AddActivityNFT(NFTId[0]._id, activityBody).then((data) => {
//                 toast.success("Auction created successfully!");
//                 // setTimeout(() => navigate("/live-auctions"), 2000);
//               });
//             });
//           } else {
//             console.error("Unable to find Transfer event in raw logs.");
//           }
//         }
//       });
//     }
//   };

//   const checksetApproved = async (e) => {
//     e.preventDefault();
//     try {
//       // const Provider = new BrowserProvider(window.ethereum);
//       const wallet = await PROVIDER.getSigner();

//       const contracts = new ethers.Contract(
//         formData.nftContract,
//         collectionABI,
//         wallet
//       );

//       const test = await contracts.setApprovalForAll(
//         fractional_nft_contract_address,
//         true
//       );
//       const receipt = await test.wait();
//       if (receipt) {
//         console.log("res", receipt);
//         handleSubmit(e);
//       }
//     } catch (error) {
//       toast.error("Error calling function:", error);
//     }
//   };

//   const validateFields = () => {
//     let newErrors = {};

//     if (!formData.campaignName.trim())
//       newErrors.campaignName = "Campaign Name is required";
//     if (!formData.campaignDescription.trim())
//       newErrors.campaignDescription = "Campaign Description is required";
//     if (!formData.category) newErrors.category = "Category is required";
//     if (!formData.media) newErrors.media = "Campaign Media is required";
//     if (!formData.fractionalTokenName)
//       newErrors.fractionalTokenName = "Token Name is required";
//     if (!formData.desire) newErrors.desire = "Fund Desired is required";
//     if (!formData.campaignEndTime)
//       newErrors.campaignEndTime = "Campaign End Date is required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//         return (
//           <div className="campaign-creation-container container">
//             <Form className="space-y-4">
//               <div className="d-flex gap-4">
//                 <Form.Group className="flex-grow-1">
//                   <p>Campaign Name</p>
//                   <Form.Control
//                     type="text"
//                     className="form-control"
//                     placeholder="Campaign Name"
//                     name="campaignName"
//                     isInvalid={!!errors.campaignName}
//                     defaultValue={formData.campaignName}
//                     onChange={handleChange}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.campaignName && (
//                       <p className="error">{errors.campaignName}</p>
//                     )}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </div>

//               <Form.Group>
//                 <p>Campaign Description</p>
//                 <Form.Control
//                   onChange={(e) => handleChange(e)}
//                   as="textarea"
//                   name="campaignDescription"
//                   rows={4}
//                   //   {...register('bio')}
//                   defaultValue={formData.campaignDescription || ""}
//                   isInvalid={!!errors.campaignDescription}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.campaignDescription && (
//                     <p className="error">{errors.campaignDescription}</p>
//                   )}
//                 </Form.Control.Feedback>
//               </Form.Group>

//               <Form.Group controlId="documentType">
//                 <p>Category</p>
//                 <Form.Control
//                   as="select"
//                   // {...register('documentType')}
//                   onChange={handleChange}
//                   name="category"
//                   isInvalid={!!errors.category}
//                 >
//                   <option value="">Select Category</option>
//                   <option value="Art">Art</option>
//                   <option value="Collectibles">Collectibles</option>
//                   <option value="Gaming">Gaming</option>
//                   <option value="Real Estate">Real Estate</option>
//                   <option value="Music">Music</option>
//                   <option value="Charity">Charity</option>
//                   <option value="Other">Other</option>
//                 </Form.Control>
//                 <Form.Control.Feedback type="invalid">
//                   {errors.category && (
//                     <p className="error">{errors.category}</p>
//                   )}
//                 </Form.Control.Feedback>
//               </Form.Group>
//               <Form.Group controlId="frontImage">
//                 <p>Campaign Media</p>
//                 <Form.Control
//                   type="file"
//                   // accept="image/*"
//                   onChange={AddMedia}
//                   isInvalid={!!errors.media}
//                   name="media"
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {errors.media && <p className="error">{errors.media}</p>}
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Form>
//           </div>
//         );
//       case 1:
//         const isStepComplete = () => {
//           switch (activeStep) {
//             case 0:
//               return (
//                 formData.campaignName &&
//                 formData.campaignDescription &&
//                 formData.category &&
//                 formData.media
//               );
//             case 1:
//               return formData.nftContract && formData.nftTokenId;
//             case 2:
//               return (
//                 formData.fractionalTokenName &&
//                 formData.tokenSymbol &&
//                 formData.desire &&
//                 formData.tokens &&
//                 formData.campaignEndTime
//               );
//             default:
//               return true;
//           }
//         };

//         return (
//           <>
//             <div className="campaign-creation-container container">
//               <div className="mt-40 mb-120">
//                 <div className="row">
//                   <div className="col-lg-2"></div>
//                   <div className="col-lg-8">
//                     <div className="space-y-10 colletion_ui">
//                       <span className="variationInput">Choose Collection</span>
//                       <div className="d-flex flex-column flex-md-row p-2">
//                         <div
//                           className="isSelected_collection d-flex justify-content-between"
//                           onClick={() => setCollectionshow(!collectionshow)}
//                         >
//                           <div className="d-flex justify-content-start">
//                             <img
//                               src={selectCollection.logo}
//                               alt="Collection Icon"
//                             />
//                             <div>
//                               <span className="ml-10">
//                                 {selectCollection.name}
//                               </span>
//                               <p className="ml-10">{selectCollection.symbol}</p>
//                             </div>
//                           </div>
//                           <div>
//                             {collectionshow ? (
//                               <MdKeyboardArrowUp size={32} />
//                             ) : (
//                               <MdOutlineKeyboardArrowDown size={32} />
//                             )}
//                           </div>
//                         </div>
//                       </div>

//                       {collectionshow && (
//                         <div className="colletion_ui_data">
//                           {collection.map((data, i) => (
//                             <div
//                               key={i}
//                               className={`${
//                                 data.isActive
//                                   ? "isSelected_collection"
//                                   : "choose_collection"
//                               } d-flex justify-content-start m-2`}
//                               onClick={() => addCollection(i, true, data)}
//                             >
//                               <img
//                                 src={data.logo || `img/logos/dtoc.png`}
//                                 alt="Collection Logo"
//                               />
//                               <div>
//                                 <span className="ml-10">{data.name}</span>
//                                 <p className="ml-10">{data.symbol}</p>
//                               </div>
//                             </div>
//                           ))}
//                           <div className="d-flex flex-column flex-md-row p-2">
//                             <Link
//                               to="/collectionAdd"
//                               className="choose_collection d-flex justify-content-start"
//                             >
//                               <FaCirclePlus color="black" size="50" />
//                               <div>
//                                 <span className="ml-10">Create</span>
//                                 <p className="ml-10">ERC-721</p>
//                               </div>
//                             </Link>
//                           </div>
//                         </div>
//                       )}
//                       {nfts.length !== 0 ? (
//                         <div
//                           className="nft-cards row"
//                           style={{ minHeight: "50vh" }}
//                         >
//                           {nfts.map((nft) => (
//                             <div
//                               key={nft.tokenId}
//                               className={`col-lg-3 col-md-6 col-sm-12 ${
//                                 formData.nftTokenId === nft.tokenId
//                                   ? "selected-nft"
//                                   : ""
//                               }`} // Add conditional class
//                               onClick={() => handleNFT(nft.tokenId)} // Handle click
//                               style={{
//                                 cursor: "pointer",
//                                 backgroundColor:
//                                   formData.nftTokenId === nft.tokenId
//                                     ? "#f0f8ff"
//                                     : "transparent", // Inline style fallback
//                                 borderRadius: "10px",
//                                 padding: "10px",
//                               }}
//                             >
//                               <div className="card__item four">
//                                 <div className="card_body space-y-10">
//                                   <div className="card_head">
//                                     {nft.assetType?.split("/")[0] !==
//                                     "image" ? (
//                                       <div className="video-wrapper">
//                                         <video
//                                           style={{ borderRadius: "18px" }}
//                                           muted
//                                           loop
//                                           playsInline
//                                         >
//                                           <source
//                                             src={nft.imageUri}
//                                             type={nft.assetType}
//                                           />
//                                           Your browser does not support the
//                                           video tag.
//                                         </video>
//                                       </div>
//                                     ) : (
//                                       <img
//                                         src={nft.imageUri}
//                                         alt={`Preview ${nft.assetType}`}
//                                         style={{ borderRadius: "18px" }}
//                                       />
//                                     )}
//                                   </div>
//                                   <div className="card_footer d-block space-y-10">
//                                     <div className="d-flex align-items-center space-x-10 justify-content-between">
//                                       <h6 className="card_title">
//                                         <div className="color_black">
//                                           {nft.title?.slice(0, 15) +
//                                             (nft.title?.length > 15
//                                               ? "..."
//                                               : "")}
//                                         </div>
//                                       </h6>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <div
//                           style={{ minHeight: "50vh" }}
//                           className="d-flex align-items-center justify-content-center"
//                         >
//                           {selectCollection.symbol !== "" ? (
//                             <div>
//                               <h2>No NFTs</h2>
//                               <Link to="/mint" className="btn btn-grad btn-lg">
//                                 Add NFT
//                               </Link>
//                             </div>
//                           ) : (
//                             <div>
//                               <h2 style={{ marginTop: "-5vh" }}>
//                                 Select A Collection
//                               </h2>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         );
//       case 2:
//         const isStepComplete = () => {
//           switch (activeStep) {
//             case 0:
//               return (
//                 formData.campaignName &&
//                 formData.campaignDescription &&
//                 formData.category &&
//                 formData.media
//               );
//             case 1:
//               return formData.nftContract && formData.nftTokenId;
//             case 2:
//               return (
//                 formData.fractionalTokenName &&
//                 formData.tokenSymbol &&
//                 formData.desire &&
//                 formData.tokens &&
//                 formData.campaignEndTime
//               );
//             default:
//               return true;
//           }
//         };

//         return (
//           <div className="campaign-creation-container container">
//             <div className=" mt-40 mb-120">
//               <div className="row">
//                 <div className="form-group space-y-10">
//                   <div className="space-y-20">
//                     <div className="space-y-10">
//                       <span className="nameInput">Token Name</span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Token Name"
//                         name="fractionalTokenName"
//                         value={formData.fractionalTokenName}
//                         onChange={handleChange}
//                       />
//                       {errors.fractionalTokenName && (
//                         <p className="error">{errors.fractionalTokenName}</p>
//                       )}
//                     </div>

//                     <div className="space-y-10">
//                       <span className="nameInput">Token Symbol</span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Token Symbol"
//                         name="tokenSymbol"
//                         value={formData.tokenSymbol}
//                         onChange={handleChange}
//                       />
//                       {errors.tokenSymbol && (
//                         <p className="error">{errors.tokenSymbol}</p>
//                       )}
//                     </div>
//                     <div className="space-y-10">
//                       <span className="nameInput">Fund Desired (ETH)</span>
//                       <input
//                         type="number"
//                         className="form-control"
//                         placeholder="Fund Desire"
//                         name="desire"
//                         value={formData.desire}
//                         onChange={handleChange}
//                       />
//                       {errors.desire && (
//                         <p className="error">{errors.desire}</p>
//                       )}
//                     </div>
//                     <div className="space-y-10">
//                       <span className="nameInput"> Total Tokens Supply</span>
//                       <input
//                         type="number"
//                         className="form-control"
//                         placeholder="Total Tokens"
//                         name="tokens"
//                         value={formData.tokens}
//                         onChange={handleChange}
//                       />
//                       {errors.tokens && (
//                         <p className="error">{errors.tokens}</p>
//                       )}
//                     </div>

//                     <div className="space-y-10">
//                       <span className="nameInput">Campaign End Date</span>
//                       <input
//                         type="datetime-local"
//                         className="form-control"
//                         name="campaignEndTime"
//                         value={formData.campaignEndTime}
//                         onChange={handleChange}
//                       />
//                       {errors.campaignEndTime && (
//                         <p className="error">{errors.campaignEndTime}</p>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
//       case 3:
//         const isStepComplete = () => {
//           switch (activeStep) {
//             case 0:
//               return (
//                 formData.campaignName &&
//                 formData.campaignDescription &&
//                 formData.category &&
//                 formData.media
//               );
//             case 1:
//               return formData.nftContract && formData.nftTokenId;
//             case 2:
//               return (
//                 formData.fractionalTokenName &&
//                 formData.tokenSymbol &&
//                 formData.desire &&
//                 formData.tokens &&
//                 formData.campaignEndTime
//               );
//             default:
//               return true;
//           }
//         };

//         return (
//           <div className="campaign-creation-container container">
//             <div className="b mt-40 mb-120">
//               <div className="row">
//                 {/* <div className="col-lg-2"></div>
//                 <div className="col-lg-8"> */}
//                 <form className="form-group space-y-10">
//                   <div className="space-y-20">
//                     {/* Campaign Name */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Campaign Name</span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Campaign Name"
//                         name="campaignName"
//                         value={formData.campaignName}
//                         onChange={handleChange}
//                       />
//                       {errors.campaignName && (
//                         <p className="error">{errors.campaignName}</p>
//                       )}
//                     </div>

//                     {/* Campaign Description */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Campaign Description</span>
//                       <textarea
//                         className="form-control"
//                         placeholder="Campaign Description"
//                         name="campaignDescription"
//                         value={formData.campaignDescription}
//                         onChange={handleChange}
//                       />
//                       {errors.campaignDescription && (
//                         <p className="error">{errors.campaignDescription}</p>
//                       )}
//                     </div>

//                     {/* Category */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Category</span>
//                       <select
//                         className="form-control"
//                         name="category"
//                         value={formData.category}
//                         onChange={handleChange}
//                       >
//                         <option value="">Select Category</option>
//                         <option value="Art">Art</option>
//                         <option value="Collectibles">Collectibles</option>
//                         <option value="Gaming">Gaming</option>
//                         <option value="Real Estate">Real Estate</option>
//                         <option value="Music">Music</option>
//                         <option value="Charity">Charity</option>
//                         <option value="Other">Other</option>
//                       </select>
//                       {errors.category && (
//                         <p className="error">{errors.category}</p>
//                       )}
//                     </div>

//                     {/* Campaign Media */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Campaign Media</span>
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="media"
//                         onChange={AddMedia}
//                       />
//                       {formData.media && (
//                         <div className="media-preview mt-10">
//                           <p>
//                             <strong>Current Media:</strong>
//                           </p>
//                           <img
//                             src={formData.media}
//                             alt="Campaign Media"
//                             style={{ width: "100%", borderRadius: "10px" }}
//                           />
//                         </div>
//                       )}
//                       {errors.media && <p className="error">{errors.media}</p>}
//                     </div>

//                     {/* Selected Collection */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Selected Collection</span>
//                       <div className="selected-collection">
//                         {selectCollection.name ? (
//                           <div className="d-flex align-items-center">
//                             <img
//                               src={selectCollection.logo}
//                               alt="Collection Logo"
//                               style={{ width: "50px" }}
//                             />
//                             <div className="ml-10">
//                               <p>
//                                 <strong>Name:</strong> {selectCollection.name}
//                               </p>
//                               <p>
//                                 <strong>Symbol:</strong>{" "}
//                                 {selectCollection.symbol}
//                               </p>
//                             </div>
//                           </div>
//                         ) : (
//                           <p>No collection selected</p>
//                         )}
//                       </div>
//                     </div>

//                     {/* Selected NFT */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Selected NFT</span>
//                       {formData.nftTokenId ? (
//                         <div className="nft-preview">
//                           <p>
//                             <strong>NFT Title:</strong>{" "}
//                             {nfts.find(
//                               (nft) => nft.tokenId === formData.nftTokenId
//                             )?.title || "N/A"}
//                           </p>
//                           {nfts
//                             .find((nft) => nft.tokenId === formData.nftTokenId)
//                             ?.type?.split("/")[0] === "image" ? (
//                             <img
//                               src={
//                                 nfts.find(
//                                   (nft) => nft.tokenId === formData.nftTokenId
//                                 )?.image
//                               }
//                               alt="Selected NFT"
//                               style={{ width: "100%", borderRadius: "10px" }}
//                             />
//                           ) : (
//                             <video
//                               style={{ width: "100%", borderRadius: "10px" }}
//                               muted
//                               loop
//                               playsInline
//                             >
//                               <source
//                                 src={
//                                   nfts.find(
//                                     (nft) => nft.tokenId === formData.nftTokenId
//                                   )?.image
//                                 }
//                                 type={
//                                   nfts.find(
//                                     (nft) => nft.tokenId === formData.nftTokenId
//                                   )?.type
//                                 }
//                               />
//                             </video>
//                           )}
//                         </div>
//                       ) : (
//                         <p>No NFT Selected</p>
//                       )}
//                     </div>

//                     {/* Token Name */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Token Name</span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Token Name"
//                         name="fractionalTokenName"
//                         value={formData.fractionalTokenName}
//                         onChange={handleChange}
//                       />
//                       {errors.fractionalTokenName && (
//                         <p className="error">{errors.fractionalTokenName}</p>
//                       )}
//                     </div>

//                     {/* Token Symbol */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Token Symbol</span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Token Symbol"
//                         name="tokenSymbol"
//                         value={formData.tokenSymbol}
//                         onChange={handleChange}
//                       />
//                       {errors.tokenSymbol && (
//                         <p className="error">{errors.tokenSymbol}</p>
//                       )}
//                     </div>

//                     {/* Fund Desired */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Fund Desired (ETH)</span>
//                       <input
//                         type="number"
//                         className="form-control"
//                         placeholder="Fund Desired"
//                         name="desire"
//                         value={formData.desire}
//                         onChange={handleChange}
//                       />
//                       {errors.desire && (
//                         <p className="error">{errors.desire}</p>
//                       )}
//                     </div>

//                     {/* Total Tokens Supply */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Total Tokens Supply</span>
//                       <input
//                         type="number"
//                         className="form-control"
//                         placeholder="Total Tokens"
//                         name="tokens"
//                         value={formData.tokens}
//                         onChange={handleChange}
//                       />
//                       {errors.tokens && (
//                         <p className="error">{errors.tokens}</p>
//                       )}
//                     </div>

//                     {/* Campaign End Date */}
//                     <div className="space-y-10">
//                       <span className="nameInput">Campaign End Date</span>
//                       <input
//                         type="datetime-local"
//                         className="form-control"
//                         name="campaignEndTime"
//                         value={formData.campaignEndTime}
//                         onChange={handleChange}
//                       />
//                       {errors.campaignEndTime && (
//                         <p className="error">{errors.campaignEndTime}</p>
//                       )}
//                     </div>
//                   </div>
//                   {/* <div style={{ float: "right" }}>
//                     <button
//                       className="btn btn-prev"
//                       onClick={() => handlePrevious(4)}
//                       disabled={activeTab === 1 || activeTab === 2 || activeTab === 3}
//                     >
//                       Previous
//                     </button>
//                     <button
//                       className="btn btn-next"
//                       onClick={(e) => checksetApproved(e)}
//                     >
//                       Submit
//                     </button>   */}
//                   {/* </div> */}
//                 </form>
//                 {/* </div>
//                 <div className="col-lg-2"></div> */}
//               </div>
//             </div>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   const isStepComplete = () => {
//     switch (activeStep) {
//       case 0:
//         return (
//           formData.campaignName &&
//           formData.campaignDescription &&
//           formData.category &&
//           formData.media
//         );
//       case 1:
//         return formData.nftContract && formData.nftTokenId;
//       case 2:
//         return (
//           formData.fractionalTokenName &&
//           formData.tokenSymbol &&
//           formData.desire &&
//           formData.tokens &&
//           formData.campaignEndTime
//         );
//       default:
//         return true;
//     }
//   };

//   return (
//     <div className="campaign-creation-container container">
//       <Link to="/launchpad" className="btn btn-white btn-sm my-40">
//         back to LaunchPad
//       </Link>
//       <Paper sx={{ p: 3 }}>
//         <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
//           {steps.map((label) => (
//             <Step key={label}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         <form>
//           {renderStepContent(
//             activeStep,
//             formData,
//             handleChange,
//             AddMedia,
//             errors
//           )}

//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//             <Button
//               variant="outlined"
//               disabled={activeStep === 0}
//               onClick={handleBack}
//             >
//               Back
//             </Button>
//             {/* {activeStep !== steps.length - 1 ? ( */}
//             <Button
//               type="button"
//               variant="contained"
//               onClick={(e) => handleNext(e)}
//             >
//               {activeStep !== steps.length - 1 ? "Next" : "Submit"}
//             </Button>
//             {/* // ) 
//             // : (
//             //   <Button type="submit"   variant="contained" onClick={(e) => checksetApproved(e)}>Submit</Button>
//             // )
//             // } */}
//           </Box>
//         </form>
//       </Paper>
//     </div>
//   );
// };

// export default CampaignCreationForm;
